import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/cloudhub.webp';
import screenshot_target from '../../../images/letterfunnel/susantmallick.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Susant Mallick"
      firstname="Susant"
      companyname="CloudHub"
      competition="GoDataDriven en Luminis"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/susantmallick.js